import './Bay.scss';
import Header from '../../common/Header/Header';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Packages from '../../api/controllers/Packages/Packages';
import Hub from '../../api/controllers/Hub/Hub';
import Error from '../../common/Error/Error';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import PackageList from '../../common/PackageList/PackageList';

const Bay = () => {
  const [bay, setBay] = useState();
  const [packages, setPackages] = useState();
  const [unassignedPackages, setUnassignedPackages] = useState();
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const location = useLocation();

  const [bays, setBays] = useState();
  const [racks, setRacks] = useState();

  const bayId = location.pathname.split('/')[2];
  const hubId = JSON.parse(localStorage.getItem('user')).currentHubId;

  const onScan = response => {
    if (response.category == 'package' && response.id) {
      if (packages.find(item => item.id == response.id)) {
        removeFromBay(response.id);
      } else {
        addToBay(response.id);
      }
    }
  };

  const removeFromBay = id => {
    setLoading(true);
    Packages.update(id, { bayId: null })
      .then(() => {
        getFromAPI();
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const addToBay = id => {
    setLoading(true);
    Packages.update(id, { bayId: bay.id })
      .then(() => {
        getFromAPI();
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getBay = async () => {
    Hub.show(hubId)
      .then(response => {
        setBay(response.bays.find(b => b.id == bayId));
        setBays(response.bays.filter(bay => bay.bayType != 'racking'));
        const racks = response.bays.filter(bay => bay.bayType == 'racking');
        setRacks(Object.groupBy(racks, rack => rack.bayNumber));
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getPackages = async () => {
    Packages.all({ hubId: hubId, bayId: bayId, status: 'in_warehouse' })
      .then(response => {
        setPackages(response.items);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getUnassigned = async () => {
    await Packages.all({ hubId: hubId, bayId: null, status: 'in_warehouse' })
      .then(response => {
        setUnassignedPackages(response.items);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getFromAPI = async () => {
    setLoading(true);
    if (bayId !== 'none') {
      getPackages();
    }
    await getUnassigned();
    setLoading(false);
  };

  useEffect(() => {
    getBay();
    getFromAPI();
  }, []);

  return (
    <div className="bay_container">
      <Header
        leftButton={'back'}
        rightButton={'home'}
        onScan={onScan}
        hideQR={bayId == 'none'}
        title={bayId == 'none' && 'Unallocated'}
      />
      {error && (
        <Error
          errorMessages={error}
          type={'info'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's occurred:' : ' occurred:'} `
              : ''
          }
        />
      )}
      {loading && <LoadingSpinner />}
      {bay && packages && (
        <div className="bay_packages_container">
          <div className="divider" />
          <div className="bay_title">
            {`${packages.length} unit${
              packages.length > 1 ? 's' : ''
            } in bay ${`${bay.bayType[0]}${bay.bayNumber}`.toUpperCase()}`}
          </div>
          <PackageList
            disableMassAssign
            packages={packages}
            refetchPackages={() => {
              getFromAPI();
            }}
            specialActionType={'bay_remove'}
            specialAction={removeFromBay}
          />
        </div>
      )}
      {unassignedPackages && (
        <div className="bay_unassigned_packages_container">
          <div className="divider" />
          <div className="bay_title">{`${unassignedPackages.length} unit${
            unassignedPackages.length > 1 ? 's' : ''
          } not in a bay`}</div>
          <PackageList
            bays={bays}
            racks={racks}
            disableMassAssign
            packages={unassignedPackages}
            refetchPackages={() => {
              getFromAPI();
            }}
            specialActionType={bayId == 'none' ? 'bay_assign' : 'bay_add'}
            {...(bayId != 'none' && { specialAction: addToBay })}
          />
        </div>
      )}
    </div>
  );
};

export default Bay;
